import { useSelector } from 'react-redux';
import { State } from 'router5';
import { PageLayout } from './form/PageLayout';
import { selectRoute } from './router';

export const AppWrapped = () => {
  const route = useSelector(selectRoute);

  return <App route={route} />;
};

type AppProps = { route: State | null };

export const App = ({ route }: AppProps) => {
  return <PageLayout />;
};
